import { Schema } from "effect";

/** One Square payment device available to operational order filters. */
export const PaymentDeviceSchema = Schema.Struct({
  device_id: Schema.NonEmptyString,
  provider_name: Schema.optional(Schema.NonEmptyString),
  name: Schema.NonEmptyString,
  last_seen_at: Schema.String,
});

/** Devices observed for the configured merchant. */
export const PaymentDevicesResponseSchema = Schema.Struct({
  devices: Schema.Array(PaymentDeviceSchema),
});

/** Path identifying a device owned by the configured merchant. */
export const PaymentDevicePathParamsSchema = Schema.Struct({
  merchantId: Schema.NonEmptyString,
  deviceId: Schema.NonEmptyString,
});

/** Staff-assigned device name. */
export const RenamePaymentDeviceRequestSchema = Schema.Struct({
  name: Schema.Trim.pipe(Schema.minLength(1), Schema.maxLength(60)),
});
